import { render } from "./TreeDownNode.vue?vue&type=template&id=4e8c61f2&scoped=true"
import script from "./TreeDownNode.vue?vue&type=script&lang=js"
export * from "./TreeDownNode.vue?vue&type=script&lang=js"

import "./TreeDownNode.vue?vue&type=style&index=0&id=4e8c61f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8c61f2"]])

export default __exports__